export enum LocalStorageKey {
  EmailLastUsed = "EmailLastUsed",
}
